//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { TaxInputItem } from './TaxInputItem';
import { CashType } from './Enums';

export class CashUpdateItem extends ItemBase {
    CashType: CashType = CashType.Revenue;
    Amount: number = 0;
    CashCategoryID: string | null = null;
    Payee: string | null = null;
    Date: string = "1970-01-01T00:00:00";
    Description: string | null = null;
    PaymentMethod: string | null = null;
    UpdateFutureCashEntries: boolean = false;
    RepeatDetails: RepeatDetailsItem | null = null;
    Taxes: TaxInputItem[] = [];

    constructor(initializer?: Partial<CashUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CashUpdateItem";
}
